import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { RequestTypeSelect } from "components/UI/RequestTypeSelect";
import { AirTrackingCheckboxGroupData } from "constants/checkboxGroupData.constants";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const AirTrackingAccess = () => {
  return (
    <>
      <div className={styles.wrapperInputs}>
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many AWBs (air waybills) do you need to track per month?"
          fieldName={INPUT_FIELD_NAMES.airTrackingmonthly_shipments}
          className={styles.perDay}
        />
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many licenses (subaccounts) do you need?"
          fieldName={INPUT_FIELD_NAMES.airTrackingLicences}
          className={styles.license_count}
        />
      </div>
    </>
  );
};
